import CRUDService from "./geral/CRUDService";
import {http} from "../config/Constantes";

export default class MOTService extends CRUDService{
    constructor() {
        super("mot");
    }

    contratosAnteriores() {
        return http.get("/"+this.serviceName+"/contratosanteriores")
    }

    validarCpf(validarCpfRequest) {
        return http.post("/"+this.serviceName+"/validarcpf", validarCpfRequest )
    }

    listByPrefixoNome(nome) {
        return http.get(`/${this.serviceName}/prefixo/${encodeURIComponent(nome)}`);
    }

    listByIds(ids) {
        return http.post(`/${this.serviceName}/ids`, ids);
    }

    //RHFPP-1013 - Consulta Quarentena
    findHistoricoContratacao(cpf) {
        return http.post(`/${this.serviceName}/historico-contratacao/`, cpf);
    }
    simularQuarerena(cpf) {
        return http.post(`/${this.serviceName}/simular-quarentena/`, cpf);
    }
    //RHFPP-1548 - Consulta Custo Mot
    calcularCustoMot(filtro) {
        return http.post(`/${this.serviceName}/calculo-custo-mot/`, filtro);
    }
}